
import { Vue, Component, Prop } from 'vue-property-decorator';
import InvoiceService from '@/services/invoice.service';
import lazyInject from '@/di';
import { getCurrentTime } from '@/common/utils';

@Component({
  components: {},
})
export default class LookCOeder extends Vue {
  @lazyInject(InvoiceService)
  protected invoiceService!: InvoiceService;

  @Prop()
  lookType!: string;

  @Prop()
  category!: string;

  get columns() {
    if (this.category === '5') {
      return this.selfOperatedColumns;
    }
    return this.commissionColumns;
  }

  selfOperatedColumns = [
    {
      title: '订单号',
      dataIndex: 'amap_order_id',
      align: 'center',
      width: 240,
    },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      align: 'center',
      width: 240,
    },
    {
      title: '项目名称',
      dataIndex: 'goods_name',
      align: 'center',
      width: 160,
    },
    {
      title: '核销金额',
      dataIndex: 'raw_user_pay',
      align: 'center',
      width: 120,
    },
    {
      title: '采购金额',
      dataIndex: 'purchase_amount',
      align: 'center',
      width: 120,
    },
    {
      title: '保险金额',
      dataIndex: 'raw_insurance',
      align: 'center',
      width: 120,
    },
    {
      title: '结算金额',
      dataIndex: 'verify_amount',
      align: 'center',
      width: 120,
    },
    {
      title: '开票金额',
      dataIndex: 'invoice_amount',
      align: 'center',
      width: 120,
    },
    {
      title: '核销时间',
      dataIndex: 'verify_time',
      align: 'center',
      width: 120,
    },
  ];

  commissionColumns = [
    {
      title: '高德订单号',
      dataIndex: 'amap_order_id',
      align: 'center',
      width: 240,
    },
    // {
    //   title: '城市',
    //   dataIndex: 'city',
    //   align: 'center',
    //   width: 150,
    // },
    {
      title: '门店名称',
      dataIndex: 'shop_name',
      align: 'center',
      width: 240,
    },
    {
      title: '商品名称',
      dataIndex: 'goods_name',
      align: 'center',
      width: 160,
    },
    // {
    //   title: '订单金额',
    //   dataIndex: 'order_price',
    //   align: 'center',
    //   width: 120,
    // },
    // {
    //   title: '总核销次数',
    //   dataIndex: 'tnum',
    //   align: 'center',
    //   width: 120,
    // },
    // {
    //   title: '已核销次数',
    //   dataIndex: 'cnum',
    //   align: 'center',
    //   width: 120,
    // },
    {
      title: '核销金额',
      dataIndex: 'verify_order_price',
      align: 'center',
      width: 120,
    },

    {
      title: '抽拥比例',
      dataIndex: 'com_ratio',
      align: 'center',
      width: 120,
      customRender: (text: any) => {
        return text ? `${text * 100}%` : '--';
      },
    },
    {
      title: '核销时间',
      dataIndex: 'verify_time',
      align: 'center',
      width: 120,
    },
    {
      title: '抽佣金额',
      dataIndex: 'commission_amount',
      align: 'center',
      width: 120,
    },
  ];

  pagination = {
    pageSize: 10,
    total: 0,
    current: 1,
    onChange: this.onChangePage,
  };

  visible = false;
  onClose() {
    this.visible = false;
  }
  params = {
    page: 1,
    pageSize: 10,
  };
  invoiceID = '';
  invoiceDataList = [];
  title = '';
  async init(record: any) {
    console.log(this.category, ' category');
    this.visible = true;
    // console.log(this.lookType, ' lookType');
    this.invoiceID = record.id;
    this.title = record.buyer.title;
    this.params.page = 1;
    this.params.pageSize = 10;
    this.invoiceDataList = [];
    this.pagination.total = 0;
    this.pagination.current = 1;
    await this.getInvoiceDataList(this.invoiceID, this.params);
  }
  async getInvoiceDataList(invoiceID: string, params: any) {
    let res = null;
    if (this.lookType === 'invoiceIndex') {
      res = await this.invoiceService.getInvoiceDataListByOrderId(invoiceID, params);
    } else {
      res = await this.invoiceService.getInvoiceDataList(invoiceID, params);
    }
    this.invoiceDataList = res.list;
    this.pagination.current = res.page;
    this.pagination.total = res.total;
  }
  onChangePage(page: number, pageSize: number) {
    this.params.page = page;
    this.params.pageSize = pageSize;
    this.getInvoiceDataList(this.invoiceID, this.params);
  }

  async onExport() {
    try {
      const res = await this.invoiceService.getInvoiceDataListByOrderIdExport(this.invoiceID, this.params);
      if (!res) {
        this.$message.error('导出失败');
        return;
      }
      const blob = new Blob([res], { type: 'application/vnd.ms-excel' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;

      a.download = `${this.title}_订单列表_${getCurrentTime()}.xlsx`;
      a.click();
      window.URL.revokeObjectURL(url);
      console.log(res, ' res');
    } catch (error) {
      this.$message.error('导出失败');
    }
  }
}
